import { postSanityConfig } from "./configuration"

const imageUrlBuilder = require("@sanity/image-url")
const builder = imageUrlBuilder(postSanityConfig)
export const generateImageUrl = (
  source: any,
  options?: { lowRes?: boolean }
) => {
  const imageBuilder = builder.image(source)

  // Check if lowRes option is true and adjust the image settings accordingly
  if (options?.lowRes) {
    return imageBuilder?.width(400)?.url() // Example: Set width to 400px for low-res
  }

  return imageBuilder?.url() // Return high-res image URL by default
}
